import { render, staticRenderFns } from "./BusinessManagerSettings.vue?vue&type=template&id=29b7c485&scoped=true&"
import script from "./BusinessManagerSettings.vue?vue&type=script&lang=js&"
export * from "./BusinessManagerSettings.vue?vue&type=script&lang=js&"
import style0 from "./BusinessManagerSettings.vue?vue&type=style&index=0&id=29b7c485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b7c485",
  null
  
)

export default component.exports